import { Trans } from '@lyearn/i18n';
import { Chat, NucleoDialogue1On1ChatTalk } from '@lyearn/icons';
import { addMenuItemType, createReactExtension, PerformanceType } from '@lyearn/lygo-core';

// Wrapper that matches the 48×48 rounded-rect container style of all other AddMenu* icons.
const AddMenuRoleplayIcon = ({ className, ...rest }: React.SVGProps<SVGSVGElement>) => (
  <span
    className={`${className} inline-flex items-center justify-center rounded-[7.5px] border border-[#EAEAEA] bg-white`}
    {...(rest as any)}>
    <NucleoDialogue1On1ChatTalk className="h-24 w-24 text-icon-active" />
  </span>
);

const roleplayExtension = createReactExtension({
  name: 'ly__roleplay',
  attrs: {
    roleplayId: {
      default: null,
    },
  },
  Component: (props) => {
    const { attrs, ...rest } = props;
    const Component =
      require('@/modules/corporate/modules/course/components/RoleplayCardContainer').default;
    return <Component {...attrs} {...rest} />;
  },
  menuItem: [
    {
      name: 'ly__roleplay',
      title: <Trans i18nKey="Common:ResourceType.Roleplay" />,
      icon: Chat,
      addMenuIcon: AddMenuRoleplayIcon,
      addMenuItemType: addMenuItemType.contents,
      description: <Trans i18nKey="Admin:Contents.RoleplayDescription" />,
      searchWords: ['roleplay', 'ai', 'practice', 'scenario'],
    },
  ],
  performanceType: PerformanceType.BLOCK_BASED,
});

export default roleplayExtension;
